function factory({ window, document, thn }) {
    const engine = {};
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            const lang = window.location.pathname.match(/\w{2}/)[0];
            if (lang && ctx.langs.test(lang)) {
                resolve(lang);
            }
            else {
                resolve('en');
            }
            reject('no_language');
        });
    };
    return engine;
}

export { factory };
